import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms/forms";
import { menuService } from "./masterpage.service";
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';

@Component({
  selector: 'app-masterpage',
  templateUrl: './masterpage.component.html',
  styleUrls: ['./masterpage.component.css']
})
export class MasterpageComponent implements OnInit {
  data: any;
  menuList: Array<any>=[];
  constructor(private service: menuService, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    if(localStorage.getItem("cd") == ")(*&"){
      this.fillAdminMenu();
    }
    if(localStorage.getItem("cd") == "$#@!"){
      this.fillUserMenu();
    }
  }
  toArray(answers: object) {
    return Object.keys(answers).map(key => ({
      key,
      ...answers[key]
    }))
  }
  fillAdminMenu(){
    const data = {
      userID : localStorage.getItem("userID")
    };
    this.service.fillAdminMenu(data)
    .subscribe((data1: Response) => {
      this.spinner.hide();
      this.data = data1;
      if (this.data.status == false) {
        // this.toastr.error('User name or password is invalid');
      } else {
        this.menuList = this.data.MenuList;
      }
    }, (err: HttpErrorResponse) => {
      localStorage.clear();
      this.spinner.hide();
      this.toastr.error('Something Went Wrong');
      this.router.navigate(['/aciadmin']);
    });
  }
  fillUserMenu(){
    const data = {};
    this.service.fillUserMenu(data)
    .subscribe((data1: Response) => {
      this.spinner.hide();
      this.data = data1;
      if (this.data.status == false) {
        // this.toastr.error('User name or password is invalid');
      } else {
        this.menuList = this.data.MenuList;
      }
    }, (err: HttpErrorResponse) => {
      localStorage.clear();
      this.spinner.hide();
      this.toastr.error('Something Went Wrong');
      this.router.navigate(['/']);
    });
  }
  redirectTo(componentName) {
    this.router.navigate(["/" + componentName]);
  }
}
